import "@/App.css";
import useLenis from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/sections/Navbar";
import { EmergencyBar } from "@/components/sections/EmergencyBar";
import { Hero } from "@/components/sections/Hero";
import { MarqueeStrip } from "@/components/sections/MarqueeStrip";
import { Services } from "@/components/sections/Services";
import { Manifesto } from "@/components/sections/Manifesto";
import { Guarantees } from "@/components/sections/Guarantees";
import { LeakFix } from "@/components/sections/LeakFix";
import { Gallery } from "@/components/sections/Gallery";
import { Testimonials } from "@/components/sections/Testimonials";
import { ServiceAreas } from "@/components/sections/ServiceAreas";
import { QuoteForm } from "@/components/sections/QuoteForm";
import { Footer } from "@/components/sections/Footer";
import { WhatsAppButton } from "@/components/sections/WhatsAppButton";

function App() {
  useLenis();

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <EmergencyBar />
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Services />
        <Manifesto />
        <Guarantees />
        <LeakFix />
        <Gallery />
        <Testimonials />
        <ServiceAreas />
        <QuoteForm />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
